import { Link } from 'react-router-dom';
import PublicNav from '../components/layout/PublicNav';
import PublicFooter from '../components/layout/PublicFooter';

const VALUES = [
  { icon: '⚡', title: 'Speed', desc: 'Loan decisions in minutes and disbursement within 24 hours — because waiting shouldn\'t be part of getting help.' },
  { icon: '🔒', title: 'Trust', desc: 'Bank-grade security and full transparency on every fee, rate, and repayment schedule.' },
  { icon: '🤝', title: 'Accessibility', desc: 'Financial services built for everyday Nigerians, not just the already-banked.' },
  { icon: '📈', title: 'Growth', desc: 'Tools like Trust Score and Group Ajo that reward good financial habits over time.' },
];

export default function AboutUs() {
  return (
    <div style={{ background: 'transparent', color: 'var(--text-1)', minHeight: '100vh', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>
      <PublicNav />

      <main style={{ flex: 1 }}>

      <section style={{ padding: '4.5rem 5% 3.5rem', textAlign: 'center' }}>
        <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#00C896', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: '0.75rem' }}>About Us</div>
        <h1 style={{ fontSize: 'clamp(1.8rem,3.5vw,2.6rem)', fontWeight: 900, fontFamily: 'Space Grotesk, sans-serif', letterSpacing: '-0.02em', maxWidth: 700, margin: '0 auto 1.25rem' }}>
          Building Nigeria's most trusted financial platform
        </h1>
        <p style={{ fontSize: '1rem', color: 'var(--text-2)', lineHeight: 1.75, maxWidth: 620, margin: '0 auto' }}>
          PCredit brings loans, bills, savings, and group contributions into one secure app —
          so managing your money never means juggling five different services.
        </p>
      </section>

      <section style={{ padding: '0 5% 4.5rem' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.25rem' }}>
          {VALUES.map(({ icon, title, desc }) => (
            <div key={title} style={{ padding: '1.5rem', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16 }}>
              <div style={{ fontSize: '1.6rem', marginBottom: '0.75rem' }}>{icon}</div>
              <div style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.4rem' }}>{title}</div>
              <div style={{ fontSize: '0.85rem', color: 'var(--text-2)', lineHeight: 1.6 }}>{desc}</div>
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: '3rem 5% 5rem', textAlign: 'center' }}>
        <Link to="/register" className="btn btn-primary btn-lg">Open a Free Account →</Link>
      </section>

      </main>

      <PublicFooter />
    </div>
  );
}
